import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';

export interface AppConfig {
  inputStyle: string;
  colorScheme: string;
  theme: string;
  ripple: boolean;
  menuMode: string;
  scale: number;
}


interface LayoutState {
  profileSidebarVisible: boolean;
  staticMenuDesktopInactive: boolean;
  overlayMenuActive:boolean;
  staticMenuMobileActive:boolean;
  showHealthIndicator: boolean;
}

@Injectable({
  providedIn: 'root'
})




export class ContextService {


  _config: AppConfig = {
    ripple: false,
    inputStyle: 'outlined',
    menuMode: 'static',
    colorScheme: 'light',
    theme: 'lara-light-indigo',
    scale: 14,
};

  config = signal<AppConfig>(this._config);

  state: LayoutState = {
    profileSidebarVisible: false,
    staticMenuDesktopInactive: true,
    overlayMenuActive: false,
    staticMenuMobileActive: false,
    showHealthIndicator: false,
};

private readonly HEALTH_INDICATOR_KEY = 'showHealthIndicator';

private overlayOpen = new Subject<any>();
overlayOpen$ = this.overlayOpen.asObservable();

showProfileSidebar() {
  this.state.profileSidebarVisible = !this.state.profileSidebarVisible;
  if (this.state.profileSidebarVisible) {
      this.overlayOpen.next(null);
  }
}


onMenuToggle() {
 
  if (this.isOverlay()) {
   
      this.state.overlayMenuActive = !this.state.overlayMenuActive;
      if (this.state.overlayMenuActive) {
          this.overlayOpen.next(null);
      }
  }

  if (this.isDesktop()) {
    
      this.state.staticMenuDesktopInactive =
          !this.state.staticMenuDesktopInactive;
  } else {
    this.state.staticMenuMobileActive =
        !this.state.staticMenuMobileActive;
      if (this.state.staticMenuMobileActive) {
          this.overlayOpen.next(null);
      }
  }
}

isDesktop() {
  return window.innerWidth > 991;
}


isOverlay() {
  return this.config().menuMode === 'overlay';
}

getShowHealthIndicator(): boolean {
  const saved = localStorage.getItem(this.HEALTH_INDICATOR_KEY);
  return saved === 'true';
}

setShowHealthIndicator(value: boolean): void {
  this.state.showHealthIndicator = value;
  localStorage.setItem(this.HEALTH_INDICATOR_KEY, String(value));
}

  constructor() {
    this.state.showHealthIndicator = this.getShowHealthIndicator();
  }

}
